<template>
  <div class="footer">
    <div class="ContactInfos">
        Copyright © 2020黄山旅游发展股份有限公司  
        <a href="https://beian.miit.gov.cn" target="_blank">皖ICP备05017153号-1 </a>
           客服：4008899808、0559-2590999    地址：
        <span>中国安徽省黄山市屯溪区天都大道005号</span>
    </div>
    <div class="footer-bootom">
      <p> 
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34100202000215" target="_blank">
          <img src="../../../assets/images/huangshan/batb.png" style="float:left;">
          皖公网安备 34100202000215号 
        </a>
        <a href="https://dxzhgl.miit.gov.cn/#/home" target="_blank">
          ICP证：皖B2-20180057 
        </a>
        <a href="https://statics.huangshan.com.cn/newlotsmallwebvue/20231109175455.jpg" target="_blank">
          营业执照
        </a>
        <span>旅游投诉电话0559-12345</span>
      </p>
      
    </div>
    <div class="agreement">
      <a href="https://w.huangshan.com.cn/vue/viewFile/userAgreement?m_id=730" target="_blank">用户协议</a>
      <a href="https://w.huangshan.com.cn/vue/viewFile/registrationProtocol?m_id=730" target="_blank">隐私政策</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
  },
}
</script>

<style scoped lang="scss">
.footer {
  padding: 80px 0;
  text-align: center;
  background-color: #171717;
  font-size: 20px;
  .ContactInfos {
    display: inline-block;
    vertical-align: middle;
    color: #c9c9c9;
    margin: 22px 15px;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    a{
      color: #c9c9c9;
    }
    a:hover{
      color: #28812e;
    }
  }
  .footer-bootom {
    width:1000px;
    margin:0 auto;
    clear: left; 
    overflow: hidden;
    p {
      float:left;
      height:20px;
      line-height:20px;
      margin: 0px 0px 0px 5px; 
      color:#939393;
      span ,a{
        margin-right: 10px;
        margin-left: 5px;
        color: #969696;
      }
      a:hover{
        color: #28812e;
      }
    }    
  }
  .agreement{
    margin-top: 22px;
    text-align: center;
    height:20px;
    line-height:20px;
    a{
      margin-right: 10px;
      margin-left: 5px;
      color: #969696;
    }
    a:hover{
      color: #28812e;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/huangshan/components/footer.vue